import React, { useState, useEffect, useRef } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import magnifierIcon from "../img/magnifier.png";
import qrCodeIcon from "../img/qr-code.png";
import scanProduct from "../img/mobileInHand.png";
import beepsound from "../assets/scanner-beep.mp3";

const HeaderComponent = () => {
  const [inputValue, setInputValue] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const scannedOnce = useRef(false);
  const [hasAudioPermission, setHasAudioPermission] = useState(false);
  const beepRef = useRef(new Audio(beepsound));

  // Handle Scan Button Click to open the modal
  const handleScanButtonClick = async () => {
    try {
      await navigator.mediaDevices.getUserMedia({ audio: true });
      setHasAudioPermission(true);
      // iOS-friendly: try to play and pause quickly during user interaction to "warm it up"
      beepRef.current.play().then(() => beepRef.current.pause());
    } catch (error) {
      setHasAudioPermission(false);
    }

    setIsModalOpen(true);
  };

  // Handle Close Modal
  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
  };

  // Handle QR Code Scan Success
  const handleScanSuccess = (decodedText) => {
    if (scannedOnce.current) return;
    scannedOnce.current = true;

    // Use a regular expression to remove everything before and including the last "/01/"
    const updatedText = decodedText.replace(/.*\/01\//, "01/");

    // Remove non-alphanumeric characters
    const trimmedText = updatedText.replace(/[^a-zA-Z0-9]/g, "");

    let formattedText = "";
    if (trimmedText.length === 16) {
      const group1 = trimmedText.substring(0, 2); // '01'
      const group2 = trimmedText.substring(2, 16); // '08691234123416'
      formattedText = `${group1}/${group2}`;
    } else if (trimmedText.length < 35) {
      const group1 = trimmedText.substring(0, 2); // '01'
      const group2 = trimmedText.substring(2, 16); // '08691234123416'
      const group3 = trimmedText.substring(16, 18); // '21'
      const group4 = trimmedText.substring(18); // '5652145895641'
      formattedText = `${group1}/${group2}/${group3}/${group4}`;
    } else {
      const group1 = trimmedText.substring(0, 2); // '01'
      const group2 = trimmedText.substring(2, 16); // '08691234123416'
      const group3 = trimmedText.substring(16, 18); // '10'
      if (group3 === "10") {
        const group4 = trimmedText.substring(18, 26); // 'D0625005'
        const group5 = trimmedText.substring(26, 28); // '21'
        const group6 = trimmedText.substring(28, 41); // '5652145895641'
        const group7 = trimmedText.substring(41, 43); // '17'
        const group8 = trimmedText.substring(43); // '240831'
        formattedText = `${group1}/${group2}/${group3}/${group4}/${group5}/${group6}?${group7}=${group8}`;
      } else {
        const group4 = trimmedText.substring(18, 31); // '5652145895641'
        const group5 = trimmedText.substring(31, 33); // '10'
        const group6 = trimmedText.substring(33, 41); // 'D0625005'
        const group7 = trimmedText.substring(41, 43); // '17'
        const group8 = trimmedText.substring(43); // '240831'
        formattedText = `${group1}/${group2}/${group5}/${group6}/${group3}/${group4}?${group7}=${group8}`;
      }
    }

    const url = `/Product/verify/${formattedText}`;
    if (hasAudioPermission) {
      const audio = beepRef.current;
      audio.currentTime = 0; // Rewind to start
      audio
        .play()
        .then(() => {
          setTimeout(() => {
            setHasAudioPermission(false);
            window.location.href = url;
          }, 90);
        })
        .catch((err) => {
          setHasAudioPermission(false);
          window.location.href = url;
        });
    } else {
      setHasAudioPermission(false);
      window.location.href = url;
    }
  };

  // Handle Search Button Click
  const handleSearchClick = () => {
    if (inputValue.length === 14) {
      const url = `/Product/verify/01/${inputValue}`;
      window.location.href = url;
    } else if (inputValue.length > 0) {
      const url = `/Product/verify/21/${inputValue}`;
      window.location.href = url;
    } else {
      const url = `/Product/NotFound`;
      window.location.href = url;
    }
  };

  // Handle QR Code Scan Error
  const handleScanError = (error) => {};

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      "qr-reader", // The ID of the element that will contain the scanner
      {
        fps: 10,
        qrbox: 250,
      }
    );
    if (isModalOpen) {
      // Start scanning
      scanner.render(handleScanSuccess, handleScanError);
    } else {
      return () => {
        scanner.clear();
      };
    }
  }, [isModalOpen]);

  return (
    <div>
      <form
        class="d-flex justify-content-center"
        role="search"
        onSubmit={(e) => {
          e.preventDefault();
          handleSearchClick();
        }}
      >
        <input
          class="form-control px-3 px-lg-4 me-2 fw-bold text-truncate"
          type="search"
          placeholder="Enter product serial number..."
          aria-label="Search"
          value={inputValue} // This should be tied to the state
          onChange={(e) => setInputValue(e.target.value)} // Update state on change
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleSearchClick();
            }
          }}
        />
        <button
          class="btn bg-color-primary text-color-white d-flex align-items-center p-3 px-4 fw-semibold"
          onClick={handleSearchClick}
          type="submit"
        >
          <img
            src={magnifierIcon}
            alt="Search Icon"
            class="me-2 me-lg-3 icon-sizes"
          />
          Search
        </button>
      </form>

      <button
        class="btn bg-color-primary text-color-white d-flex justify-content-center align-items-center w-100 mt-3 py-3 fw-semibold"
        data-bs-toggle="modal"
        data-bs-target="#exampleModal"
        type="button"
        onClick={handleScanButtonClick}
      >
        <img
          src={qrCodeIcon}
          alt="QR Code Icon"
          class="me-2 me-lg-3 icon-sizes"
        />
        Scan Product
      </button>

      <div
        class="modal fade"
        tabIndex="-1"
        id="exampleModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content text-color-white">
            <div class="modal-header">
              <img
                src={scanProduct}
                alt="Scan Product"
                class="me-2 icon-sizes"
              />
              <h5 class="modal-title"> Scan Code</h5>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleModalClose()}
              ></button>
            </div>
            <div class="modal-body text-color-white">
              <div id="qr-reader"></div>
            </div>
            <div class="modal-footer">
              <button
                onClick={() => handleModalClose()}
                type="button"
                class="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderComponent;
